const createLogger = () => {
    // In our environments `newrelic` is injected as a global client-side
    if (typeof window.newrelic !== 'undefined' && typeof window.newrelic.noticeError === 'function') {
        return window.newrelic.noticeError;
    }
    // If newrelic isn't defined, there may be other ways that window.onerror is picked up
    if (typeof window.onerror === 'function') {
        return window.onerror;
    }
    // eslint-disable-next-line
    return console.error;
};

export default createLogger;
